import Vue from 'vue';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

Vue.component('v-select', vSelect);
Vue.component('text-field', require('./components/Form/TextField').default);
Vue.component('textarea-field', require('./components/Form/TextareaField').default);
Vue.component('wysiwyg-field', require('./components/Form/WysiwygField').default);
Vue.component('date-field', require('./components/Form/DateField').default);
Vue.component('select-field', require('./components/Form/SelectField').default);
Vue.component('search-select-field', require('./components/Form/SearchSelectField').default);